"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  background: ", ";\n  color: ", ";\n  border-radius: 2px;\n  padding: 3px 8px;\n  border: 0;\n  margin: 0;\n  outline: none;\n  flex-grow: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Input = styled_components_1.default.input(_templateObject(), function (props) {
  return props.theme.toolbarInput;
}, function (props) {
  return props.theme.toolbarItem;
});
exports.default = Input;